/**
 * What the page, the recording service worker and the player document say
 * to each other.
 *
 *   page ──provision──▶ worker          (keys and index, once per playback)
 *   page ◀──ready────── player document (the iframe served by the worker)
 *   page ──load───────▶ player document (which parts to play)
 *   player document ──▶ worker          (plain GETs with Range, by <video>)
 *   page ◀──state────── player document (position, and whether it still
 *                                        has the worker)
 */
export const RECORDING_SW_URL = '/recording-sw.js';
/**
 * A service worker only sees requests of documents inside its scope. The
 * player therefore is a document of its own, inside the scope, shown in
 * an iframe; the app's pages are never controlled by the worker.
 */
export const RECORDING_SW_SCOPE = '/rec/';
export function playerDocumentUrl(token) {
    return `${RECORDING_SW_SCOPE}${token}/player`;
}
export function partUrl(token, position) {
    return `${RECORDING_SW_SCOPE}${token}/part-${position}.mp4`;
}
